<template>
  <div align="center">
    <page-header></page-header>
    <table width="98%" border="0" cellpadding="0" cellspacing="0" class="table_green" bgcolor="#e7f3d6">
      <tbody>
        <tr>
          <td width="10" height="25">&nbsp;</td>
          <td width="100%" align="left" valign="middle">
            <img src="../../../assets/img/jt.jpg" width="9" height="9" style="margin:0 5px;">{{$t('currlocation')}}:{{$t('index')}}
            <img src="../../../assets/img/jt.gif">{{$t('adminProc')}}
            <img src="../../../assets/img/jt.gif">{{$t('adminProc_02')}}
          </td>
        </tr>
      </tbody>
    </table>
    <container-bottom :link-to="{name:'user-manager-add'}"></container-bottom>
    <pagination v-if="records.length > 0" :total="total" @current-change="changePage" :pageSize="50" :current-page="currentPage"></pagination>
    <table-no-record v-if="records.length == 0"></table-no-record>
    <table v-if="records.length >0" width="98%" cellpadding="1" cellspacing="1" class="main_talbe">
      <!--DWLayoutTable-->
      <tbody>
        <tr class="trtitle">
          <td width="20%" height="20" valign="middle">{{$t('admin_user_code')}}</td>
          <td width="28%">{{$t('admin_user_name')}}</td>
          <td width="16%">{{$t('admin_user_type')}}</td>
          <td width="28%">{{$t('normal_po_remark')}}</td>
          <td width="8%">{{$t('document_word1')}}</td>
        </tr>
        <tr v-for="(record, index) in records" :class="[index%2!=0?'tr1':'tr2']" @mouseout="trOnmouseout($event,index)" @mouseover="trOnMouseover($event)">
          <td height="18" valign="middle">{{record.userCode}}</td>
          <td valign="middle">{{record.userName}}</td>
          <td valign="middle">
            {{getUserTypeValue(record)}}
          </td>
          <td valign="middle">{{record.remark}}</td>
          <td>
            <router-link :to="{name:'login'}">{{$t('document_word2')}}</router-link> |
            <router-link :to="{name:'login'}">{{$t('document_word3')}}</router-link>
          </td>
        </tr>
      </tbody>
    </table>

    <page-footer></page-footer>
  </div>
</template>
<script>
import PageFooter from "@/components/infrastructure/layout/page-footer.vue";
import PageHeader from "@/components/infrastructure/layout/page-header.vue";
import ContainerBottom from "@/components/infrastructure/layout/container-bottom.vue";
import TableNoRecord from "@/components/infrastructure/table/table-no-record.vue";
import Pagination from "@/components/infrastructure/pagination/index.vue";

import { GetUserPageList } from "@/api/user";
export default {
  components: {
    PageHeader,
    PageFooter,
    ContainerBottom,
    TableNoRecord,
    Pagination,
  },
  data() {
    return {
      records: [],
      total: 0,
      currentPage: 1,
    };
  },
  mounted() {
    this.query();
  },
  methods: {
    changePage(page) {
      if (this.currentPage == page) {
        return;
      }
      this.currentPage = page;
      this.query();
    },
    async query() {
      var res = await GetUserPageList({
        page: this.currentPage,
        row: 50,
      }).getResponseAsync();

      if (res === null) {
        return;
      }

      this.records = res.data.listTo;
      this.total = res.data.totalLength;
      window.scrollTo(0, 0);
    },
    trOnMouseover(event) {
      event.target.className = "shen";
    },
    trOnmouseout(event, index) {
      if (index % 2 == 0) {
        event.target.className = "tr2";
      } else {
        event.target.className = "tr1";
      }
    },
    getUserTypeValue(record) {
      var type = "";
      switch (record.userType) {
        case "A":
          type = "admin_user_typeA";
          break;
        case "B":
          type = "admin_user_typeB";
          break;
        case "C":
          type = "admin_user_typeC";
          break;
        case "D":
          type = "admin_user_typeD";
          break;
      }

      if (type.length == 0) {
        return "";
      }

      return this.i18n.t(type);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/index.css";
</style>